module.exports = __webpack_public_path__ + "img/file-upload-illustration.6e172045.png";